import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSubmit } from "module/common/components/forms";
import { putDNCStatus } from "module/main/store/appEndpoints/api";
var DNC = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var curatedPayload = {
            numbers: request.numbers
                .split(/[\n,]+/)
                .map(function (number) { return number.trim(); })
                .filter(Boolean),
        };
        formSubmitCallBack(putDNCStatus, curatedPayload);
    });
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "DNC status:" }), _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "numbers", className: "font-bold text-slate", children: "Phone Numbers" }), _jsx("textarea", { id: "numbers", className: "min-h-[120px] rounded-xl border border-sherpaChocoCream bg-white px-4 py-3 text-sm text-ink outline-none transition placeholder:text-mutedBlue/60 focus:border-primary focus:ring-2 focus:ring-primary/10", placeholder: "Enter one phone number per line, or comma separated", name: "numbers", required: true })] })] }));
};
export default DNC;
